{
  "version": 1,
  "asset_id": "a682e630-21e1-4234-95d7-48392a546f23",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a682e630-21e1-4234-95d7-48392a546f23/sleeve-amateur-2.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a682e630-21e1-4234-95d7-48392a546f23/sleeve-amateur-2.webp",
  "original_filename": "sleeve-amateur-2.webp",
  "size": 146426,
  "content_type": "image/webp",
  "created_at": "2026-08-15T18:28:53Z"
}
